import axios from 'axios';
import settings from '/settings';
import qs from 'qs';
import env from '/env';
import errorMsgUtil from './err_msg_util';
import { jwtDecode } from 'jwt-decode';
import configConstructor from "../configConstructor";

export const Request = axios.create({
  headers: {
    'Authorization': configConstructor?.getPermissionToken()
    //'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.1H7PNzuqxPSvelQNkMSETWyF8FBumtjNVxJwUWWN7g0'
  }
});

Request.interceptors.request.use(
  config => {
      config.headers.Authorization = configConstructor.getPermissionToken();
    return config;
  },
  error => Promise.reject(error)
);

const noWarningStatusCode = [404];
// Keeping the code for future use
// const customWarningMicroService = [];
// const shouldErrorMessageBeDisplayed = (statusCode, microService) => {
//   let isCustomMessage = statusCode && statusCode == 400 && customWarningMicroService.includes(microService);
//   return statusCode && !noWarningStatusCode.includes(statusCode) && !isCustomMessage;
// }

Request.interceptors.response.use(
  response => response,
  error => {
    let statusCode = (error.response || {}).status;

    // Keeping the code for future use
    // let microService = (error.config?.url || '').split('/')[3];
    // if(shouldErrorMessageBeDisplayed(statusCode, microService))
    //   errorMsgUtil(error);

    if(statusCode && !noWarningStatusCode.includes(statusCode)) errorMsgUtil(error);
    return Promise.reject(error);
  }
)

// Separate axios instance for auth-related calls that need session ID
export const AuthRequest = axios.create({
  headers: {
    'Authorization': configConstructor?.getPermissionToken()
  }
});

AuthRequest.interceptors.request.use(
  config => {
    config.headers.Authorization = configConstructor.getPermissionToken();
    const sessionId = localStorage.getItem('los_session_id');
    if (sessionId) config.headers['X-Auth-Session-Id'] = sessionId;
    return config;
  },
  error => Promise.reject(error)
);

AuthRequest.interceptors.response.use(
  response => response,
  error => {
    let statusCode = (error.response || {}).status;
    if(statusCode && !noWarningStatusCode.includes(statusCode)) errorMsgUtil(error);
    return Promise.reject(error);
  }
);

export const RequestMultipartHeader = axios.create({ 
  headers: {
    "Content-Type": "multipart/form-data" 
  }
});

export const RequestBase64Header = (contentType, url, base64Data) => {
  return axios.put(url, base64Data, {
    headers: {
      'Content-Type': contentType,
      'Content-Encoding': 'base64'
    }
  })
}

export const refreshRequest = axios.create({});

// refreshRequest.interceptors.request.use(config => {
//   const sessionId = sessionStorage.getItem('los_session_id');
//   if (sessionId) config.headers['X-Auth-Session-Id'] = sessionId;
//   return config;
// });

export const getAPIHost = () => `${env['API_HOST'].split('.').slice(-2).join('.')}`;

export const getReportingHost = () => `${env['REPORTING_HOST'].split('.').slice(-2).join('.')}`;

export const getQueryString = (query) => {
  try {
    // if the query is already a string, use it
    if (typeof query === 'string') {
      // just in case the query came with a leading ?
      return `?${query}`.replace(/^\?\?+/, '?');
    }

    const queryString = qs.stringify(query);
    return queryString.length ? `?${queryString}` : '';
  } catch (err) {
    return '';
  }
}

export const getRealm = () => {
  const rlm = window.location.hostname.split('.');
  return rlm.length == 3 ? rlm[0] : '';
};

export const getHost = () => window.location.host.split('.').slice(-2).join('.');

// getHost() sans port number
export const getHostname = () => window.location.hostname.split('.').slice(-2).join('.');

export const getLoginUrl = realm => `${env['API_HOST']}/auth/sp/login?realm=${realm}`;

export const getLogoutUrl = realm => `${env['API_HOST']}/auth/sp/logout?realm=${realm}`;

export const getRefreshToken = (realm) => {
  const headers = {};
  const sessionId = localStorage.getItem("los_session_id");
  if (sessionId) headers["X-Auth-Session-Id"] = sessionId;
  return refreshRequest.get(
    `${env["API_HOST"]}/auth/sp/refreshToken?realm=${realm}`,
    {
      withCredentials: true,
      headers,
    },
  );
};

export const getPermissionToken = () => {
  const isDevEnv = env.APP_ENV === 'development';
  const realm = getRealm();
  if(isDevEnv){
    let token = localStorage.getItem(settings.getLocalTokenName());
    return Promise.resolve({
      data: {
        "permissions_token": token,
        "index_permissions_token": token || ""
      }
    });
  }else{
    const headers = {};
    const sessionId = localStorage.getItem('los_session_id');
    if (sessionId) headers['X-Auth-Session-Id'] = sessionId;
    return AuthRequest.get(`${env['API_HOST']}/auth/sp/permissionToken?realm=${realm}`, { withCredentials: true, headers });
  }
} 

export const getBrandFavicon = (realm) => axios.get(`${window.location.origin}/brands/${realm}/favicon.ico`)

export const getAccessibility = (realm) => {
  const result = axios.get(`${window.location.origin}/brands/${realm}/accessbility.json`)
  return result;
}

export const getRSAPublicKey = () => {
  try {
    const realm = getRealm();
    const token = configConstructor.getPermissionToken();
    const auth = token ? jwtDecode(token) : null;

    let PUBLIC_KEY_PATH_URL;

    if(env['APP_ENV'] === 'development') {
      PUBLIC_KEY_PATH_URL = `https://${realm || auth.realm}.cyncsoftware.com`;
    } else {
      PUBLIC_KEY_PATH_URL =  env['API_HOST'].split('.');
      PUBLIC_KEY_PATH_URL = `${PUBLIC_KEY_PATH_URL[0].split('//')[0]}//${realm || auth.realm }.${PUBLIC_KEY_PATH_URL[1]}.${PUBLIC_KEY_PATH_URL[2]}`;
    }

    PUBLIC_KEY_PATH_URL += '/rsa_pub.js';

    return Request.get(PUBLIC_KEY_PATH_URL);
  } catch(error) {
    return null;
  } 
};

